module.exports = __webpack_public_path__ + "static/media/YF57_3.97e36d57.jpg";